import Utils from "../../services/Utils.js";

export function getGameTemplate(game, gameType) {
  if (!game.odd) {
    return "";
  }

  return `
        <div class="flex flex-row flex-wrap w-full px-1 pt-[5px] items-center">
            <div class="cursor-pointer">
                <div class="flex flex-row flex-wrap">
                    <a class="cursor-pointer" href="#/Match/${
                      game.id
                    }" data-id="${game.id}">
                        <span class="flex w-full w-[40px] text-center text-[11px] leading-[20px] text-white justify-center font-[verdana]">${
                          game.game_time.split(":")[0]
                        }:${game.game_time.split(":")[1]}</span>
                    </a>
                    <a class="cursor-pointer quickBetBetBtn" quick-code="${
                      game.game_code
                    }">
                        <span class="flex w-full w-[45px] text-center text-[11px] leading-[20px] text-white justify-center font-[verdana]">${
                          game.game_code || "-"
                        }</span>
                    </a>
                </div>
            </div>
            <div 
                class="
                    flex
                    cursor-pointer
                    ${
                      gameType == 2 ||
                      gameType == 5 ||
                      gameType == 10 ||
                      gameType == 3
                        ? `w-[166px]`
                        : "w-[130px]"
                    }
                    text-white
                    text-[11px]
                    leading-[20px]
                    px-2
                    bg-black/30
                    hover:bg-[#8d741d]
                    justify-between
                    mr-[1px]
                    singleHomeOdd 
                    bettingBtn 
                    ${
                      Utils.formatNumber(
                        game.odd.split(",")[0].split("|")[1]
                      ) == 1
                        ? "disabledBtn"
                        : ""
                    }
                    ${
                      game.odd.split(",").length > 0
                        ? game.odd.split(",")[0].split("|")[0]
                        : "disabledBtn"
                    }
                " 
                match-code="${game.game_code || "-"}"
                match-odd="${
                  game.odd.split(",").length > 0
                    ? Utils.formatNumber(game.odd.split(",")[0].split("|")[1])
                    : ""
                }" 
                match-home-name="${game.home_team}" 
                match-away-name="${game.away_team}" 
                match-market="Rezultat Final" 
                match-market-option="1 "
                coef-id="${
                  game.odd.split(",").length > 0
                    ? game.odd.split(",")[0].split("|")[0]
                    : ""
                }" 
                bet-id="${
                  game.odd.split(",").length > 0
                    ? game.odd.split(",")[0].split("|")[0]
                    : ""
                }" 
                game-id="${game.id}"
            >
                
                <span class="${
                  gameType == 2 ||
                  gameType == 5 ||
                  gameType == 10 ||
                  gameType == 3
                    ? `w-[140px]`
                    : "w-[75px]"
                } truncate whitespace-nowrap overflow-hidden text-ellipsis">${
    game.home_team
  }</span>
                <span> ${
                  game.odd.split(",").length > 0
                    ? Utils.formatNumber(game.odd.split(",")[0].split("|")[1])
                    : ""
                }</span>
            </div>
            <div 
                class="
                    flex
                    cursor-pointer
                    ${
                      gameType == 2 ||
                      gameType == 5 ||
                      gameType == 10 ||
                      gameType == 3
                        ? `w-[167px]`
                        : "w-[78px]"
                    }
                    text-white
                    text-[11px]
                    leading-[20px]
                    px-2
                    bg-black/30
                    hover:bg-[#8d741d]
                    mr-[1px]
                    justify-between
                    singleDrawOdd
                    bettingBtn
                     ${
                       Utils.formatNumber(
                         game.odd.split(",")[1].split("|")[1]
                       ) == 1
                         ? "disabledBtn"
                         : ""
                     }
                    ${
                      game.odd.split(",").length > 1
                        ? game.odd.split(",")[1].split("|")[0]
                        : "disabledBtn"
                    }
                " 
                match-code="${game.game_code || "-"}"
                match-odd="${
                  game.odd.split(",").length > 1
                    ? Utils.formatNumber(game.odd.split(",")[1].split("|")[1])
                    : ""
                }" 
                match-home-name="${game.home_team}" 
                match-away-name="${game.away_team}" 
                match-market="Rezultat Final" 
                match-market-option="X "
                coef-id="${
                  game.odd.split(",").length > 1
                    ? game.odd.split(",")[1].split("|")[0]
                    : ""
                }" 
                bet-id="${
                  game.odd.split(",").length > 1
                    ? game.odd.split(",")[1].split("|")[0]
                    : ""
                }" 
                game-id="${game.id}"
            >
                <span class="${
                  gameType == 2 ||
                  gameType == 5 ||
                  gameType == 10 ||
                  gameType == 3
                    ? `w-[75px] truncate whitespace-nowrap overflow-hidden text-ellipsis`
                    : ""
                }">${
    gameType == 2 || gameType == 5 || gameType == 10 ? game.away_team : "X"
  }</span>
                <span>${
                  game.odd.split(",").length > 1
                    ? Utils.formatNumber(game.odd.split(",")[1].split("|")[1])
                    : ""
                }</span>
            </div>
            ${
              game.odd.split(",").length == 3 &&
              game.odd.split(",")[2].split("|").length > 1
                ? `
                <div 
                    class="
                        flex
                        cursor-pointer
                        w-[130px]
                        text-white
                        text-[11px]
                        leading-[20px]
                        px-2
                        font-[verdana]
                        bg-black/30
                        hover:bg-[#8d741d]
                        justify-between
                        mr-[1px]
                        singleAwayOdd 
                        bettingBtn  
                       ${
                         Utils.formatNumber(
                           game.odd.split(",")[2].split("|")[1]
                         ) == 1
                           ? "disabledBtn"
                           : ""
                       } ${
                    game.odd.split(",").length > 2
                      ? game.odd.split(",")[2].split("|")[0]
                      : "disabledBtn"
                  }
                        ${
                          game.odd.split(",").length > 2
                            ? game.odd.split(",")[2].split("|")[0]
                            : "disabledBtn"
                        }
                    "
                    match-code="${game.game_code || "-"}"
                    match-odd="${
                      game.odd.split(",").length > 2
                        ? Utils.formatNumber(
                            game.odd.split(",")[2].split("|")[1]
                          )
                        : ""
                    }" 
                    match-home-name="${game.home_team}" 
                    match-away-name="${game.away_team}" 
                    match-market-option="2 "
                    match-market="Rezultat Final" 
                    coef-id="${
                      game.odd.split(",").length > 2
                        ? game.odd.split(",")[2].split("|")[0]
                        : ""
                    }" 
                    bet-id="${
                      game.odd.split(",").length > 2
                        ? game.odd.split(",")[2].split("|")[0]
                        : ""
                    }" 
                    game-id="${game.id}"
                >
                    <span class="${
                      gameType == 2 ||
                      gameType == 5 ||
                      gameType == 10 ||
                      gameType == 3
                        ? `w-[140px]`
                        : "w-[75px]"
                    } truncate whitespace-nowrap overflow-hidden text-ellipsis">${
                    game.away_team
                  }</span>
                    <span> ${
                      game.odd.split(",").length > 2
                        ? Utils.formatNumber(
                            game.odd.split(",")[2].split("|")[1]
                          )
                        : ""
                    }</span>
                </div>
            `
                : ``
            }
            <div class="flex-1 justify-end flex flex-row flex-wrap"><span class="border border-white bg-[#0066cc] text-white text-[11px] w-[16px] h-[16px] ml-[4px] leading-[14px] text-center font-bold">1</span></div>
        </div>
    `;
}
